module.exports = __webpack_public_path__ + "img/arrow-up.05c5afee.svg";